<template>
  <!-- Table Container Card -->
  <b-card
    v-if="campaigns"
    no-body
  >
    <div class="m-1">
      <!-- Table Top -->
      <b-row>
        <!-- Title -->
        <b-col
          cols="6"
          class="d-flex align-items-end justify-content-start"
        >
          <h4>{{ $t('campaigns') }}</h4>
        </b-col>
        <!-- Create button -->
        <b-col
          cols="6"
        >
          <div
            v-if="!isEmpty(user) && user.payment.type === 'business' && user.payment.campaignSize < campaignSize"
            class="d-flex align-items-center justify-content-end"
          >
            <b-button
              v-ripple.400="'rgba(40, 199, 111, 0.15)'"
              variant="flat-primary"
              class="btn-icon"
              @click="$emit('update')"
            >
              <feather-icon
                size="20"
                icon="PlusIcon"
              />
            </b-button>
          </div>
        </b-col>
      </b-row>
    </div>

    <b-table
      :items="campaigns"
      responsive
      :fields="fields"
    >
      <!-- company -->
      <template #cell(campaignName)="data">
        <div class="d-flex align-items-center text-nowrap">
          <b-avatar
            size="32"
            :src="require(`@/assets/images/icons/campaign-icons/${data.item.types[0]}.svg`)"
          />
          <div class="ml-1">
            <div class="font-weight-bolder">
              {{ data.item.campaignName }}
            </div>
            <div class="font-small-2 text-muted">
              {{ data.item.slug }}
            </div>
          </div>
        </div>
      </template>

      <template #cell(types)="data">
        <div class="d-flex align-items-center text-nowrap">
          <b-badge
            v-for="(type, idx) in data.item.types"
            :key="idx"
            class="profile-badge mr-1"
            variant="light-primary"
          >
            {{ type }}
          </b-badge>
        </div>
      </template>

      <!-- Column: Status -->
      <template #cell(status)="data">
        <b-badge
          pill
          :variant="`light-${statusVariant(data.item.status)}`"
          class="text-capitalize text-center"
        >
          {{ $t(data.item.status) }}
        </b-badge>
      </template>

      <!-- Column: Actions -->
      <template #cell(actions)="data">
        <b-dropdown
          variant="link"
          no-caret
          class="d-flex"
        >

          <template #button-content>
            <feather-icon
              icon="MoreVerticalIcon"
              size="16"
              class="align-middle text-body"
            />
          </template>
          <b-dropdown-item :to="{ name: 'campaign', params: { slug: data.item.slug } }">
            <feather-icon icon="FileTextIcon" />
            <span class="align-middle ml-50">列印與編輯</span>
          </b-dropdown-item>

          <b-dropdown-item
            v-if="data.item.status === 'eligible'"
            @click="updateStatus(data.item, 'paused')"
          >
            <feather-icon icon="PauseIcon" />
            <span class="align-middle ml-50">暫停</span>
          </b-dropdown-item>

          <b-dropdown-item
            v-if="data.item.status === 'paused'"
            @click="updateStatus(data.item, 'eligible')"
          >
            <feather-icon icon="PlayIcon" />
            <span class="align-middle ml-50">啟用</span>
          </b-dropdown-item>

          <b-dropdown-item
            v-if="data.item.status === 'paused'"
            @click="confirmDelete(data.item)"
          >
            <feather-icon icon="TrashIcon" />
            <span class="align-middle ml-50">刪除</span>
          </b-dropdown-item>

        </b-dropdown>
      </template>
    </b-table>
  </b-card>
</template>

<script>
import {
  BCard, BTable, BButton, BRow, BCol, BDropdown, BDropdownItem, BBadge, BAvatar,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { mapGetters } from 'vuex'
import store from '@/store'

export default {
  components: {
    BBadge,
    BRow,
    BCol,
    BCard,
    BTable,
    BAvatar,
    BButton,
    BDropdown,
    BDropdownItem,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      fields: [
        { key: 'campaignName', label: this.$t('campaign'), thClass: 'text-nowrap' },
        { key: 'types', label: this.$t('types'), thClass: 'text-nowrap' },
        { key: 'totalRecords', label: this.$t('check-ins'), thClass: 'text-nowrap' },
        { key: 'status', label: this.$t('status'), thClass: 'text-nowrap' },
        { key: 'actions', label: this.$t('actions'), thClass: 'text-nowrap text-center' },
      ],
      dataMeta: {},
      totalUsers: 12,
      perPage: 2,
      currentPage: 1,
      recordCounts: {},
    }
  },
  computed: {
    ...mapGetters(['userCampaigns', 'user', 'campaigns', 'campaignSize']),
  },
  async mounted() {
    await this.initUser().then(() => {
      this.initCampaigns()
    })
  },
  methods: {
    createNew() {
      this.$emit('update')
    },
    initUser() {
      return new Promise((resolve, reject) => {
        if (!this.user) {
          store.dispatch('fetchUserProfile').then(() => {
            resolve()
          }).catch(() => {
            reject()
          })
        } else {
          resolve()
        }
      })
    },
    initCampaigns() {
      return new Promise((resolve, reject) => {
        if (!this.campaigns && this.user) {
          store.dispatch('fetchCampaigns', { uid: this.user.uid }).then(() => {
            resolve()
          }).catch(() => {
            reject()
          })
        } else if (!this.user) {
          reject()
        } else {
          resolve()
        }
      })
    },
    confirmDelete(campaign) {
      this.$swal({
        title: '確定要刪除嗎?',
        text: '刪除以後便無法恢復！',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: '確定, 刪除！',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          this.deleteCampaign(campaign).then(() => {
            this.$swal({
              icon: 'success',
              title: '成功刪除',
              text: `${campaign.campaignName} 已經被刪除了`,
              customClass: {
                confirmButton: 'btn btn-success',
              },
            })
          })
        }
      })
    },
    updateStatus(campaign, status) {
      store.dispatch('updateCampaignStatus', {
        cuid: this.user.uid,
        userCampaigns: this.userCampaigns,
        campaign,
        campaigns: this.campaigns,
        status,
      })
    },
    async deleteCampaign(campaign) {
      await store.dispatch('updateCampaignStatus', {
        cuid: this.user.uid,
        userCampaigns: this.userCampaigns,
        campaign,
        status: 'deleted',
      })
    },
    statusVariant: (status => {
      // ['eligible', 'paused', 'deleted', 'ended', 'pending', 'suspended']
      if (status === 'eligible') return 'success'
      if (status === 'paused') return 'secondary'
      if (status === 'suspended') return 'danger'
      return 'primary'
    }),
  },
}
</script>

<style>
  .table-responsive {
    height: 100%;
  }
</style>
